import React, {useRef, useState} from 'react';
import PropTypes from 'prop-types';

import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {convertirModena } from "../../../../shared/utils/utils";
import {UsePermissions} from "../../../../hooks/usePermissions";
import NumberFormat from "react-number-format";
import {ColumnGroup} from "primereact/columngroup";
import {Row} from "primereact/row";
import {Toast} from "primereact/toast";
import {confirmDialog} from "primereact/confirmdialog";
import {UseLoader} from "../../../../hooks/useLoader";
import {crearLiquidacion} from "../../../../api/liquidacion.service";


export const TableEditEvento = ({liquidacion, factura, reload}) => {
    const toast = useRef(null);
    const [handleLoad] = UseLoader();
    const [permisos] = UsePermissions()
    const [totalSuma, setTotalSuma] = useState(0);


    const textEditor = (options) => {
        return <NumberFormat
            id="valor"
            thousandsGroupStyle="thousand"
            value={options.value}
            prefix="$"
            displayType="input"
            type="text"
            decimalSeparator="."
            className="form-input-small "
            thousandSeparator={true}
            allowNegative={true}
            onValueChange={(e) => options.editorCallback(e.value)}
        />
    }

    const OnSave = () => {
        if (Math.round(totalSuma) > Math.round(parseFloat(factura.valor_neto)) || Math.round(totalSuma) < Math.round(parseFloat(factura.valor_neto))) {
            toast.current?.show({
                severity: 'warn',
                summary: 'Alerta',
                detail: `La suma total de los valores debe ser al e valor facturado`,
                life: 3000
            });
            return;
        }

        confirmDialog({
            message: '¿Estas seguro?',
            header: 'Confirmación',
            acceptLabel: "Si",
            rejectLabel: "No",
            accept: async () => {
                handleLoad(true);
                const payload = {
                    tipo: "E",
                    datos: liquidacion
                }
                const response = await crearLiquidacion(payload);

                handleLoad(false)

                if (response.estado !== 200) {
                    toast.current?.show({severity: 'error', summary: 'Alerta', detail: response.mensaje, life: 3000});
                    return;
                }

                toast.current?.show({severity: 'success', summary: 'Exito', detail: response.mensaje, life: 3000});
                reload()
            }
        });
    }

    const valorBrutoDistribucion = (porcentaje) => {
        for (let liq of liquidacion) {

            liq.valor = isNaN(Math.round(liq.valor_neto * (1 + porcentaje))) ? 0 : Math.round(liq.valor_neto * (1 + porcentaje));
        }
    }


    const valorNetoTotal = () => {
        let total = 0;
        let porceIndividual = 0;
        for (let liq of liquidacion) {

            total += liq.valor_neto === '' ? 0 : parseFloat(liq.valor_neto);
            porceIndividual = factura.valor_descuento / total;

        }
        valorBrutoDistribucion(porceIndividual)

        setTotalSuma(total)
        return convertirModena(total);
    }

    const valorBrutoTotal = () => {
        let total = 0;
        for (let liq of liquidacion) {
            total += liq.valor === '' ? 0 : parseFloat(liq.valor);
        }
        return convertirModena(total);
    }

    let footerGroup =
        <ColumnGroup>
            <Row>
                <Column footer="" colSpan={0} footerStyle={{marginLefth: '10px'}}/>
                <Column footer={valorNetoTotal}/>

                <Column footer={valorBrutoTotal}/>
            </Row>
            <Row>


            </Row>
        </ColumnGroup>;


    const header = (
        <div className="flex align-items-center justify-between">
            <div>
                <button
                    className="primary-color-btn btn"
                    type="button"
                    disabled={(!permisos.adicionar)}
                    onClick={OnSave}
                >
                    <i className="fa fa-save"/>
                </button>
            </div>
        </div>
    );


    const onCellEditComplete = (e) => {
        let {rowData, newValue, field, originalEvent: event} = e;
        if (newValue.trim().length > 0) {
            rowData[field] = newValue;
        } else {
            event.preventDefault();
        }
    }

    const footer = (
        <div className="flex align-items-center  ">
            <p className={totalSuma > parseInt(factura.valor_neto) ? 'p-2  text-sm text-red-600' : 'p-2 text-sm text-teal-600 '}>
                Valor neto factura: {convertirModena(factura.valor_neto)}</p>

        </div>
    );

    const valueBodyTemplateNeto = (rowData) => {
        return convertirModena(rowData.valor_neto);
    }

    return (
        <>
            <Toast ref={toast}/>
            <DataTable
                showGridlines
                value={liquidacion}
                size="small"
                editMode="cell"
                dataKey="id"
                header={header}
                footer={footer}
                scrollable scrollHeight="400px"
                footerColumnGroup={footerGroup}
                responsiveLayout="scroll">
                <Column filter sortable field="afiliados" header="Afiliados" style={{width: '10%'}}></Column>
                <Column field="valor_neto" header="Valor neto"
                        onCellEditComplete={onCellEditComplete}
                        editor={(options) => textEditor(options)}
                         style={{width: '10%'}}></Column>
                <Column field="valor_neto" body={valueBodyTemplateNeto} header="Valor neto $" style={{width: '10%'}}></Column>
                <Column field="valor" header="Valor bruto" style={{width: '10%'}}></Column>


            </DataTable>
        </>
    );
};

TableEditEvento.prototype = {
    liquidacion: PropTypes.array
}

TableEditEvento.defaultProps = {
    liquidacion: []
}
